<app-megamenu></app-megamenu>

<div class="pest-library-page">
  <!-- Hero Section -->
  <div class="hero-section">
    <div class="container">
      <div class="hero-content">
        <h1>Pest Library</h1>
        <p class="hero-subtitle">Learn about common pests found in Utah homes and businesses. Get expert information on identification, prevention, and treatment options.</p>
      </div>
    </div>
  </div>

  <!-- Filter Section -->
  <div class="filter-section">
    <div class="container">
      <h2>Browse by Category</h2>
      <div class="category-filters">
        <div class="chip-container">
          <button 
            *ngFor="let category of categories"
            class="category-chip"
            [class.selected]="selectedCategory === category"
            (click)="selectCategory(category)"
          >
            {{ category }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Pests Grid -->
  <div class="pests-section">
    <div class="container">
      <div class="pests-grid">
        <mat-card *ngFor="let pest of filteredPests" class="pest-card">
          <div class="pest-image">
            <img [src]="pest.image" [alt]="pest.name" />
            <div class="danger-badge" [style.background-color]="getDangerColor(pest.dangerLevel)">
              {{ pest.dangerLevel }} Risk
            </div>
          </div>
          
          <mat-card-content class="pest-content">
            <div class="pest-header">
              <h3>{{ pest.name }}</h3>
              <p class="scientific-name">{{ pest.scientificName }}</p>
            </div>
            
            <p class="pest-description">{{ pest.description }}</p>
            
            <div class="pest-details">
              <div class="detail-item">
                <mat-icon>home</mat-icon>
                <span>{{ pest.habitat }}</span>
              </div>
              <div class="detail-item">
                <mat-icon>schedule</mat-icon>
                <span>{{ pest.seasonality }}</span>
              </div>
            </div>
            
            <div class="common-signs">
              <h4>Common Signs:</h4>
              <ul>
                <li *ngFor="let sign of pest.commonSigns">{{ sign }}</li>
              </ul>
            </div>
          </mat-card-content>
          
          <mat-card-actions>
            <button mat-raised-button class="learn-more-btn" (click)="viewPestDetails(pest.id)">
              <mat-icon>info</mat-icon>
              Learn More
            </button>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>
  </div>

  <!-- CTA Section -->
  <div class="cta-section">
    <div class="container">
      <h2>Need Professional Pest Control?</h2>
      <p>Our experts can identify and eliminate any pest problem. Get a free consultation today.</p>
      <div class="cta-buttons">
        <button mat-raised-button class="primary-cta" routerLink="/contact">
          <mat-icon>request_quote</mat-icon>
          Get Free Quote
        </button>
        <button mat-button class="secondary-cta" routerLink="/services">
          <mat-icon>pest_control</mat-icon>
          View Services
        </button>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>